import { IResourceBase } from 'app/shared/utils/resourcefiles.utils';
export const ZERO_REF = '0000000000000000000000000000000000000000';
// Format of vsts repo url: https://${accountName}.visualstudio.com/${projectName}/_apis/git/repositories/${repoName}
// Format of devops repo url: https://dev.azure.com/${accountName}/${projectName}/_apis/git/repositories/${repoName}
// Mantaining both formats in case there are old factories which still use tags and contain the old url version.
export const GIT_VSTS_REPO_REGEX: RegExp = /^https:\/\/((dev\.azure\.com\/(.+)\/(.+))|((.+)\.visualstudio\.com\/(.+)))\/_apis\/git\/repositories\/(.+)$/;
export const GIT_REPO_TAG = '__gitRepoUrl__';
export const GIT_REPO_COLLABORATION_BRANCH = '__gitRepoCollaborationBranch__';
export const GIT_REPO_ROOT_FOLDER = '__gitRepoRootFolder__';
export const GIT_REPO_TENANT = '__gitRepoTenant__';

export const GIT_MASTER_BRANCH: string = 'master';
export const DEFAULT_PUBLISH_BRANCH: string = __IS_A365__ ? 'workspace_publish' : 'adf_publish';

export const BRANCHES = 'heads';
export const TAGS = 'tags';
export type RefType = 'heads' | 'tags';

interface IGitResource {
    gitObjectType: string;
    path: string;
    objectId: string;
}
export interface IListReponse {
    value: IGitResource[];
}

export interface IBranchCreationStatus {
    status: BranchStatus;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

export interface IGitRefPayload {
    name: string;
    oldObjectId: string;
    newObjectId: string;
}

interface IChangedItem {
    gitObjectType: 'tree' | 'blob';
    path: string;
    commitId: string;
}

export interface IChangedResponse {
    item: IChangedItem;
    changeType: string;
    sourceServerItem?: string;
}

type CommitableChangeType = 'edit' | 'add' | 'rename' | 'delete';

export interface ICommitableChange {
    changeType: CommitableChangeType;
    item: ICommitChangeItem;
    newContent?: IItemContent;
    sourceServerItem?: string;
}

export interface ISeparatedCommitsItem {
    commits: ICommitableChange[];
    size: number;
}

export interface IGitAuthContext {
    type: 'oauth' | 'token';
    token: string;
}

export interface IGitTokenConfig {
    token: string;
    tokenSaveType: TokenSaveType;
}

interface ICommitChangeItem {
    path: string;
}

interface IItemContent {
    content: string;
    contentType: 'rawtext';
}

interface IRefUpdate {
    name: string;
    oldObjectId: string;
}

export interface IPushBody {
    refUpdates: IRefUpdate[];
    commits: ICommit[];
}

interface ICommit {
    comment: string;
    changes: ICommitableChange[];
}

export function branchToRef(branchName: string): string {
    return `refs/${BRANCHES}/${branchName}`;
}

export function tagToRef(tagName: string): string {
    return `refs/${TAGS}/${tagName}`;
}

export interface ICommitContext {
    filePath: (resourceBase: IResourceBase, rootFolder?: string) => string;
    branchName: string;
}

export enum BranchStatus {
    Exists = 0,
    CreateSuccess = 1,
    CreateFailed = 2
}

export enum GitType {
    Vsts = 'VSTS',
    GitHub = 'GitHub'
}

export enum GitAuthErrorCodes {
    PermissionDeniedToPushToBranch = 'TF402455',
    BranchLocked = 'TF401389',
    PermissionDeniedToCreateBranch = 'TF401027'
}

export enum GitInformationResult {
    Found,
    AccountNotFound,
    CollaborationBranchNotFound,
    BadProjectName,
    AuthenticationError,
    BadRepoName,
    UnknownError,
    TenantChangeAuthError,
    GitHubRepoConfigAuthError
}

export enum AzureDevopsType {
    Online = 'Online',
    CrossTenantSignIn = 'CrossTenantSignIn',
    Server = 'Server'
}

export interface IGitOperationResult {
    success: boolean;
    message: string;
}

export type TokenSaveType = 'DoNotSave' | 'InSessionStorage' | 'InLocalStorage';
